var map = {
  "./BDSA_clear.png": "./src/assets/BDSA_clear.png",
  "./Circles-menu-3.gif": "./src/assets/Circles-menu-3.gif",
  "./mwlogo.png": "./src/assets/mwlogo.png"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = "./src/assets sync \\.(png%7Cjpe?g%7Cgif%7Csvg%7Cwebp)$i";
